
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/cookie-management",
      function () {
        return require("private-next-pages/en/cookie-management.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/cookie-management"])
      });
    }
  